export default "__VITE_ASSET__Dc8Us5M2__"